module.exports = __webpack_public_path__ + "img/128x128_square_carrier.4b3cdbc8.svg";